import { render, staticRenderFns } from "./teaserplain.vue?vue&type=template&id=e141de8e&scoped=true&"
import script from "./teaserplain.vue?vue&type=script&lang=js&"
export * from "./teaserplain.vue?vue&type=script&lang=js&"
import style0 from "./teaserplain.vue?vue&type=style&index=0&id=e141de8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e141de8e",
  null
  
)

export default component.exports